import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';
import { colors } from '../theme/tokens';

export interface CadrePleinEcranProps {
  fond: string;
  testID?: string;
  children: React.ReactNode;
}

const SANS_MARGE = { top: 0, bottom: 0, left: 0, right: 0 };

/**
 * Cadre des écrans plein écran de la candidature (préparation, relecture, avant préparation).
 *
 * TOUT L'ÉCRAN, barre d'état comprise : posés dans le panneau de détail, ces écrans laissaient voir
 * la page d'en dessous derrière l'heure (retour de test sur iPhone, 03/10/2026). La marge du haut
 * est comptée UNE fois, par le bandeau ; elle est toujours bleu nuit, pour que les icônes blanches
 * de la barre d'état restent lisibles sur chacun de ces écrans — un seul style pour tout le
 * parcours, parce qu'Android ne relit ce style qu'à l'ouverture de la fenêtre.
 *
 * Les marges viennent du contexte de l'application (fenêtre réelle), pas d'un SafeAreaView natif :
 * dans une fenêtre modale, celui-ci ne trouve pas toujours son fournisseur.
 */
export function CadrePleinEcran({ fond, testID, children }: CadrePleinEcranProps) {
  const marges = useContext(SafeAreaInsetsContext) ?? SANS_MARGE;
  return (
    <View style={[styles.cadre, { backgroundColor: fond }]} testID={testID}>
      <View style={[styles.barreEtat, { height: marges.top }]} testID={testID ? `${testID}-barre-etat` : undefined} />
      <View style={[styles.contenu, { paddingBottom: marges.bottom }]} testID={testID ? `${testID}-contenu` : undefined}>
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  cadre: { ...StyleSheet.absoluteFillObject },
  barreEtat: { backgroundColor: colors.night },
  contenu: { flex: 1 },
});
